import * as React from "react";
import { withStyles, CircularProgress } from "@material-ui/core";
import { Render3dStore } from "../../Render3dStore";
import { observer } from "mobx-react";
import Header from "../layouts/Header";
import { NoResultsFound } from "modules/development/components/layouts";
import i18n from "i18n";

const styles = (theme) => ({
  root: {
    display: "flex",
    flex: 1,
    "flex-direction": "column",
    height: "100%",
    backgroundColor: "#e6e6e6",
    //background: "#D3D3D3",
  },
  headerContainer: {
    display: "flex",
    flex: 1,
  },
  gridContainer: {
    //background: "#D3D3D3",
    backgroundColor: "rgba(250, 250, 250, 1)",
    display: "grid",
    height: "Calc(100% - 30px)",
    width: "Calc(100%)",
    alignContent: "center",
    gridTemplateColumns: "1fr",
    position: "relative" as any,
  },
  transitionEnter: {
    opacity: 0.01,
  },
  transitionEnterActive: {
    opacity: 1,
    transition: "opacity 300ms ease-in",
  },
  transitionLeave: {
    opacity: 1,
  },
  transitionLeaveActive: {
    opacity: 0.01,
    transition: "opacity 300ms ease-in",
  },
});

type IProps = {
  classes: any;
};

@observer
class Render3D extends React.Component<IProps> {
  state = {
    developmentSelected: "",
    wbsSelected: "",
    renderWithIsolate: "",
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.headerContainer}>
          <Header name="3D" />
        </div>
        <div
          ref="container"
          className={classes.gridContainer}
          style={{ overflow: "hidden!important" }}
        >
          {Render3dStore.modelIdCollection.length === 0 &&
            !Render3dStore.loadingViewer && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "calc(100% + 30px)",
                  backgroundColor: "rgba(250, 250, 250, 1)",
                }}
              >
                <NoResultsFound
                  replaceTarget={i18n.library.message.noIFCforRender}
                  replaceSubtarget={i18n.library.message.noIFCforRenderSub}
                />
              </div>
            )}
          {Render3dStore.loadingViewer && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                backgroundColor: "rgba(250, 250, 250, 1)",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CircularProgress
                size={50}
                style={{ margin: "0 auto", color: "#9FB408" }}
              />
            </div>
          )}
          {Render3dStore.toolbarLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                backgroundColor: "rgba(250, 250, 250, 0.5)",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CircularProgress
                size={50}
                style={{ margin: "0 auto", color: "#9FB408" }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Render3D);



// WEBPACK FOOTER //
// ./src/modules/render3D/components/pages/Render3D.tsx